var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 1.75391C6.39137 1.75391 2.25 5.89527 2.25 11.0039C2.25 16.1125 6.39137 20.2539 11.5 20.2539C16.6086 20.2539 20.75 16.1125 20.75 11.0039C20.75 5.89527 16.6086 1.75391 11.5 1.75391ZM0.75 11.0039C0.75 5.06684 5.56294 0.253906 11.5 0.253906C17.4371 0.253906 22.25 5.06684 22.25 11.0039C22.25 16.941 17.4371 21.7539 11.5 21.7539C5.56294 21.7539 0.75 16.941 0.75 11.0039ZM11.5 6.25391C11.9142 6.25391 12.25 6.58969 12.25 7.00391V10.6932L14.5303 12.9736C14.8232 13.2665 14.8232 13.7413 14.5303 14.0342C14.2374 14.3271 13.7626 14.3271 13.4697 14.0342L10.9697 11.5342C10.829 11.3936 10.75 11.2028 10.75 11.0039V7.00391C10.75 6.58969 11.0858 6.25391 11.5 6.25391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock_icon.f4ed56f2e055fc2ebea01571ca747d26.svg";
export { ForwardRef as ReactComponent };